import { render } from "./DriverPage.vue?vue&type=template&id=3458d55e&scoped=true"
import script from "./DriverPage.vue?vue&type=script&lang=js"
export * from "./DriverPage.vue?vue&type=script&lang=js"

import "./DriverPage.vue?vue&type=style&index=0&id=3458d55e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3458d55e"]])

export default __exports__